import React, { useState, useEffect } from 'react';
import './index.scss';
import Button from 'b2b-ui-components-lib/lib/components/button';
import DownloadComponent from 'home/view/manage-feasibility/components/atoms/DownloadComponent';
import UploadComponent from 'home/view/manage-feasibility/components/atoms/UploadComponent';
import ToastComponent from 'common/components/toast/toast.component';
// import { Notification } from 'common/components/notification-component/notification-component';
import { Notification } from 'featureLib/NotificationComponent';

import { MULTI_SITE_MODULE_ID, AUTH_TOKEN, CART_ID, ORDER_ID, ERROR_TOAST, DEFAULT_TOAST_MSG, FILE_UPLOAD_PAGES, SUMMARY_AUTH_TOKEN } from 'home/view/manage-feasibility/constants';

import { getFromSessionStorage, getNotificationType, trackAnalytics } from 'common/utils/app.utils';

import { downloadFileURI, getFileName } from 'home/view/manage-feasibility/utils';

import { bulkDownloadAddressResolution, bulkDownloadCart, orderBulkDownload, siteReadinessBulkDownload } from 'home/view/manage-feasibility/services';

import { DEDICATED_COMMON_PARAMS } from 'common/constants/app.constants';
import { getCurrentLead, getCurrentOrder } from 'tokenGeneration/lead.util';

const Drawer = (props) => {
  const {
    isOpen = false,
    setIsOpen = () => {},
    title = '',
    onSaveClick = () => {},
    downloadHeading = '',
    downloadSubHeading = '',
    downloadBtnName = '',
    toast = {},
    setToast = () => {},
    currentPage = '',
    isdedicatedJourney = false,
    onDrawerUploadCb = () => {}
  } = props;

  useEffect(() => {
    toggelToastPopup();
  }, []);

  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
  const [isSiteDownloadInProgress, setIsSiteDownloadInProgress] = useState(false);

  const handleFileUpload = (uploadedFiles, isFileUploaded) => {
    setIsSubmitDisabled(!isFileUploaded);
    onDrawerUploadCb(uploadedFiles, isFileUploaded);
  };

  const toggelToastPopup = () => {
    setToast(false, '', '');
  };

  const getFileDefaultName = (serviceType) => {
    let downloadFileName = '';

    switch (currentPage) {
      case FILE_UPLOAD_PAGES.ADDRESS_RESOLUTION: {
        downloadFileName = `Edit_Bulk_Address_${serviceType}.xlsx`;
        break;
      }
      case FILE_UPLOAD_PAGES.CART_FEASIBILITY: {
        downloadFileName = `Edit_Cart_Bulk_Upload_${serviceType}.xlsx`;
        break;
      }
      case FILE_UPLOAD_PAGES.ORDER_SUMMARY: {
        downloadFileName = `Edit_Order_Summary_Upload_${serviceType}.xlsx`;

        break;
      }
      case FILE_UPLOAD_PAGES.SITE_READINESS: {
        downloadFileName = `Edit_Order_Summary_Upload_${serviceType}.xlsx`;

        break;
      }
      default: {
        downloadFileName = '';
      }
    }

    return downloadFileName;
  };

  const handleDownloadClick = async () => {
    const order = getCurrentOrder();
    const lead = getCurrentLead();
    trackAnalytics({
      eVar9: `b2b|${order?.serviceType}|buy|confirm installations|site readiness widget|edit with excel|download excel`,
      prop0: `b2b|${order?.lead?.customer?.segment}|${order?.serviceType}`,
      prop15: order?.customerEmail || '', //email address
      prop17: `${order?.lead?.customer?.authorizedSignatory?.firstName || ''} ${order?.lead?.customer?.authorizedSignatory?.lastName || ''}`, //full name
      prop14: order?.lead?.customer?.authorizedSignatory?.phoneNumber || '', //phone number
      prop35: order?.companyAddress?.officeName || '',
      prop39: order?.lead?.customer?.segment || '',
      prop40: order?.serviceType || '',
      prop37: order?.orderType || '',
      // prop41=<type of site>
      // Prop43=<no. of sites>
      // prop21=<feasibility request id>
      // Prop23=<link id>
      prop9: order?.companyAddress?.pincode || '',
      prop36: order?.lead?.customer?.authorizedSignatory?.companyName || '',
      prop20: order?.companyAddress?.addressLine1 || '',
      // Prop26=<bandwidth>
      // Prop28=<site type>
      prop10: order?.orderId || '',
      // Prop29=<media type>
      // Prop22=<contract period>
      prop18: order?.lead?.planDetail?.totalPrice || '',
      prop1: order?.purchaseOrder?.poNumber || '',
      prop24: order?.documents?.PURCHASE_ORDER?.PO_DOCUMENT || '',
      prop25: order?.purchaseOrder?.purchaseOrderDate || '',
      prop2: order?.purchaseOrder?.poAmount || '',
      prop3: order?.billingType || '',
      prop4: order?.billingCycle || '',
      prop5: order?.lead?.customer?.panNumber || '', //<account number>
      prop16: order?.companyAddress?.city || '',
      // Prop7=<full name of site contact details>
      // Prop8=<mobile number of site contact details>
      // Prop9=<email address of site contact details>
      // Prop37=<customer need by date>
      prop38: order?.fiscalCode?.id || ''
      // Prop11=<full name of CPM>
      // Prop12=<mobile number of CPM>
      // Prop13=<email address of CPM>
    });
    try {
      setIsSiteDownloadInProgress(true);

      const { res, err } = await getDownloadApi();
      if (res) {
        const { data = {} } = res;
        const serviceType = DEDICATED_COMMON_PARAMS.serviceType;
        const fileName = getFileName(res, getFileDefaultName(serviceType));
        downloadFileURI(data, fileName);

        setIsSiteDownloadInProgress(false);
      } else if (err) {
        const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;

        setIsSiteDownloadInProgress(false);
        setToast(true, errorMsg, ERROR_TOAST);

        throw new Error(errorMsg);
      }
    } catch (e) {
      setIsSiteDownloadInProgress(false);
      console.error(e);
    }
  };

  const getDownloadApi = () => {
    const leadAuthToken = getFromSessionStorage(MULTI_SITE_MODULE_ID, AUTH_TOKEN);

    const cartId = getFromSessionStorage(MULTI_SITE_MODULE_ID, CART_ID);

    const orderAuthToken = getFromSessionStorage(MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN);

    const orderId = getFromSessionStorage(MULTI_SITE_MODULE_ID, ORDER_ID);

    switch (currentPage) {
      case FILE_UPLOAD_PAGES.ADDRESS_RESOLUTION: {
        return bulkDownloadAddressResolution(leadAuthToken);
      }
      case FILE_UPLOAD_PAGES.CART_FEASIBILITY: {
        return bulkDownloadCart(leadAuthToken, isdedicatedJourney, cartId);
      }
      case FILE_UPLOAD_PAGES.ORDER_SUMMARY: {
        return orderBulkDownload(orderId, orderAuthToken, isdedicatedJourney);
      }
      case FILE_UPLOAD_PAGES.SITE_READINESS: {
        return siteReadinessBulkDownload(orderId, orderAuthToken, isdedicatedJourney);
      }
      default: {
        return () => {};
      }
    }
  };

  const sendAnalytics = (type) => {
    const order = getCurrentOrder();
    const lead = getCurrentLead();
    trackAnalytics({
      eVar9: `b2b|${order?.serviceType}|buy|confirm installations|site readiness widget|edit with excel page|${type}`,
      prop0: `b2b|${order?.lead?.customer?.segment}|${order?.serviceType}`,
      prop15: order?.customerEmail || '', //email address
      prop17: `${order?.lead?.customer?.authorizedSignatory?.firstName || ''} ${order?.lead?.customer?.authorizedSignatory?.lastName || ''}`, //full name
      prop14: order?.lead?.customer?.authorizedSignatory?.phoneNumber || '', //phone number
      prop35: order?.companyAddress?.officeName || '',
      prop39: order?.lead?.customer?.segment || '',
      prop40: order?.serviceType || '',
      prop37: order?.orderType || '',
      // prop41=<type of site>
      // Prop43=<no. of sites>
      // prop21=<feasibility request id>
      // Prop23=<link id>
      prop9: order?.companyAddress?.pincode || '',
      prop36: order?.lead?.customer?.authorizedSignatory?.companyName || '',
      prop20: order?.companyAddress?.addressLine1 || '',
      // Prop26=<bandwidth>
      // Prop28=<site type>
      prop10: order?.orderId || '',
      // Prop29=<media type>
      // Prop22=<contract period>
      prop18: order?.lead?.planDetail?.totalPrice || '',
      prop1: order?.purchaseOrder?.poNumber || '',
      prop24: order?.documents?.PURCHASE_ORDER?.PO_DOCUMENT || '',
      prop25: order?.purchaseOrder?.purchaseOrderDate || '',
      prop2: order?.purchaseOrder?.poAmount || '',
      prop3: order?.billingType || '',
      prop4: order?.billingCycle || '',
      prop5: order?.lead?.customer?.panNumber || '', //<account number>
      prop16: order?.companyAddress?.city || '',
      // Prop7=<full name of site contact details>
      // Prop8=<mobile number of site contact details>
      // Prop9=<email address of site contact details>
      // Prop37=<customer need by date>
      prop38: order?.fiscalCode?.id || ''
      // Prop11=<full name of CPM>
      // Prop12=<mobile number of CPM>
      // Prop13=<email address of CPM>
    });
  };

  return (
    <div className={`drawer_modal_controller ${isOpen ? 'active' : ''}`}>
      <div className="drawer">
        {/* <section id="toast">
          {!isBulkUpgrade() && toast.show && (
            <ToastComponent topPosition={100} closeNetworkCoveragePopup={toggelToastPopup} toastMessage={toast.message} successToast={toast.type} closeToastTime={'8000'} />
          )}
        </section> */}
        <div className="drawer_header">
          <div className="container">
            <div className="drawer_head">
              <div className="title_info">
                <div className="title_heading">{title}</div>
              </div>
              <span
                className="close_icon"
                onClick={() => {
                  setIsOpen(false);
                  toggelToastPopup();
                }}
              ></span>
            </div>
          </div>
        </div>
        <div className="drawer_body">
          <div className="scroll_content">
            <div className="container">
              <section id="notification">
                <Notification
                  show={toast.show}
                  type={getNotificationType(toast.type)}
                  message={toast.message}
                  eventHandler={toggelToastPopup}
                  onCancel={toggelToastPopup}
                ></Notification>
              </section>
              <div className="configration_area">
                <DownloadComponent
                  isDrawerModal
                  heading={downloadHeading}
                  subHeading={downloadSubHeading}
                  btnName={downloadBtnName}
                  onClick={handleDownloadClick}
                  loading={isSiteDownloadInProgress}
                />
              </div>
              <div className="upload_docs_area">
                <UploadComponent isDrawerModal onUploadCb={handleFileUpload} {...props} />
              </div>
            </div>
          </div>
        </div>
        <div className="drawer_footer">
          <div className="container">
            <div className="button_group">
              <Button
                variant="outlinebtn"
                onClick={() => {
                  setIsOpen(false);
                  toggelToastPopup();
                  sendAnalytics('cancel');
                }}
              >
                Cancel
              </Button>
              <Button
                disabled={isSubmitDisabled}
                onClick={() => {
                  onSaveClick();
                  sendAnalytics('save');
                }}
              >
                Save
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Drawer;
